export function fillSpace(initialSpaceLeft, spaceType, prevVariant, variants, placementResults, frame, addToTarget) {
    const newPlacementResults = placementResults;
    if (initialSpaceLeft === 0) {
        return newPlacementResults;
    }
    let spaceLeft = initialSpaceLeft;
    const spaceLength = Math.floor(initialSpaceLeft / prevVariant.communicatedDimensions[spaceType]);
    // Create a fake array so we have something to loop from
    const arr = [...Array(spaceLength)];
    arr.forEach(() => {
        const newVariant = variants.find(v => v.communicatedDimensions[spaceType] === prevVariant.communicatedDimensions[spaceType]);
        if (newVariant && newVariant.communicatedDimensions[spaceType] <= spaceLeft) {
            newPlacementResults.push(addToTarget(newVariant.coreProductId, frame));
            spaceLeft = spaceLeft - newVariant.communicatedDimensions[spaceType];
        }
    });
    return newPlacementResults;
}
//# sourceMappingURL=fillSpace.js.map